import _Skeleton from "@mui/material/Skeleton";
import _Avatar from "@mui/material/Avatar";
import { lighten } from '@mui/material/styles';
import React from 'react';
const colors = ['#2AC682', '#BB8A1A', '#528BE8', '#F36565', '#FA823E', '#DD428D', '#CF58E1', '#743AEF', '#1589BB', '#268B1D', '#846858'];
export function GeogroupAvatar({
  geogroup,
  color,
  size: _size,
  variant
}) {
  let firstLetter = geogroup?.title && String.fromCodePoint(geogroup.title.codePointAt(0) || 0);
  if (firstLetter?.match(/[a-z]/i)) firstLetter = firstLetter?.toUpperCase();
  const size = _size || 32;
  return geogroup !== undefined ? geogroup?.photo ? /*#__PURE__*/React.createElement(_Avatar, {
    src: geogroup.photo,
    sx: {
      backgroundColor: '#fff',
      border: variant === 'outlined' ? `1px solid #DDE0E7` : undefined,
      flexShrink: 0,
      height: size,
      width: size
    }
  }) : /*#__PURE__*/React.createElement(_Avatar, {
    sx: ({
      palette
    }) => ({
      bgcolor: color ? lighten(color, 0.8) : firstLetter ? lighten(colors[firstLetter.charCodeAt(0) % colors.length], 0.8) : palette.primary.light,
      color: color || (firstLetter ? colors[firstLetter.charCodeAt(0) % colors.length] : palette.primary.light),
      flexShrink: 0,
      fontSize: size >= 48 ? '1.5rem' : undefined,
      fontWeight: size >= 48 ? 700 : undefined,
      height: size,
      width: size
    })
  }, firstLetter) : /*#__PURE__*/React.createElement(_Skeleton, {
    height: size,
    style: {
      flexShrink: 0
    },
    variant: "circular",
    width: size
  });
}